import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  params: {
    fromChannel: process.env.REACT_APP_DEFAULT_CHANNEL,
  },
});

api.interceptors.request.use(async (config) => {
  try {
    const token = localStorage.getItem("token_travel_wl_v1");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  } catch (err) {
    console.log("err", err);
  }
});

api.interceptors.response.use(
  async (config) => {
    return config;
  },
  async function (error) {
    return Promise.reject(error);
  }
);

export default api;
